module.exports = __webpack_public_path__ + "img/banner7.0c8c2941.png";